<template>
  <div class="content">
    <div class="container-fluid mt-7">
      <div class="card pb-2">
        <div :class="['card-pricing bg-white border-0 mb-4', cardClass]">
          <div :class="['pt-4 pb-3 d-flex align-items-center card-header', headerClass]">
            <h3 class="mb-0">{{ header }}</h3>
          </div>
          <div class="px-5">
            <ul class="list-unstyled my-2" v-if="formattedVariables.length > 0">
              <li v-for="(item, index) in formattedVariables" :key="index" class="border-bottom py-2">
                <div class="row flex-grow-1 d-flex justify-content-between align-items-center">
                  <div class="col-5 pl-4 font-weight-bold">
                    {{ toHeaderCase(item.name) }}
                  </div>
                  <div class="col-4 border-left">
                    {{ item.value }}
                  </div>
                  <div class="col-3 border-left d-flex justify-content-center">
                    <base-button :class="buttonClass" size="sm" @click="openEditModal(item)">
                      Edit
                    </base-button>
                  </div>
                </div>
              </li>
            </ul>
            <div v-else class="d-flex justify-content-center align-items-center text-muted h-100 py-5">
              No Data Available
            </div>
            <div class="modal fade show d-block" tabindex="-1" role="dialog" v-if="showModal">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Edit Variable</h5>
                    <button type="button" class="close" @click="closeModal">
                      <span>&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <label>Variable Name</label>
                      <input type="text" class="form-control" :value="toHeaderCase(modalData.name)" disabled />
                    </div>
                    <div class="form-group">
                      <label>Value</label>
                      <input type="text" class="form-control" v-model="modalData.value"
                        placeholder="Example : 1,2,3,4,5" />
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary" @click="closeModal">
                      Close
                    </button>
                    <button class="btn btn-primary" @click="updateVariable">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SystemVariableCard",
  props: {
    cardClass: {
      type: String,
      default: ""
    },

    headerClass: {
      type: String,
      default: ""
    },

    buttonClass: {
      type: String,
      default: ""
    },

    header: {
      type: String,
      default: "System Variables"
    }
  },
  data() {
    return {
      variableData: {},
      formattedVariables: [],
      showModal: false,
      modalData: {
        name: "",
        value: ""
      }
    };
  },
  mounted() {
    this.getVariables();
  },
  methods: {
    getVariables() {
      this.$store.dispatch(
        "variableStore/getVariableDetails",
        null,
        { root: true }
      )
        .then(response => {
          this.variableData = response.server.data || {};
          this.formattedVariables = Object.entries(this.variableData).map(
            ([key, value]) => ({
              name: key,
              value: Array.isArray(value) ? value.join(",") : value
            })
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    toHeaderCase(value) {
      if (!value) return "";
      return value
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, char => char.toUpperCase());
    },
    openEditModal(item) {
      this.modalData = {
        name: item.name,
        value: item.value
      };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    updateVariable() {
      const data = {
        variableName: this.modalData.name,
        value: this.modalData.value
      };
      this.$store.dispatch(
        "variableStore/updateVariables",
        data,
        { root: true }
      )
        .then(() => {
          const index = this.formattedVariables.findIndex(
            item => item.name === this.modalData.name
          );
          if (index !== -1) {
            this.formattedVariables[index].value = this.modalData.value;
          }
          this.closeModal();
        })
        .catch(error => {
          console.log(error);
        });
    }

  }
};
</script>

<style scoped></style>